<form *ngIf="Form" [formGroup]="Form" enctype="multipart/form-data">
  <div>
    <div class="form-group form-floating mb-3">
      <div class="form-floating mb-3" [appValidateState]="Form.get('title')">
        <div class="inpt-title">{{ "title" | transloco }}</div>
        <input
          formControlName="title"
          type="text"
          class="inpt"
          placeholder="{{ 'title' | transloco }}"
          autocomplete="off"
        />
      </div>
    </div>
    <div class="form-group form-floating mb-3">
      <div
        class="form-floating mb-3"
        [appValidateState]="Form.get('msGraphClientId')"
      >
        <div class="inpt-title">{{ "msGraphClientId" | transloco }}</div>
        <input
          formControlName="msGraphClientId"
          type="text"
          class="inpt"
          placeholder="{{ 'msGraphClientId' | transloco }}"
          autocomplete="off"
        />
      </div>
    </div>
    <div
      class="form-group form-floating mb-3"
      [appValidateState]="Form.get('msGraphClientSecret')"
    >
      <div class="inpt-title">{{ "msGraphClientSecret" | transloco }}</div>
      <input
        formControlName="msGraphClientSecret"
        type="text"
        class="inpt"
        placeholder="{{ 'msGraphClientSecret' | transloco }}"
        autocomplete="off"
      />
    </div>

    <div
      class="form-group form-floating mb-3"
      [appValidateState]="Form.get('msGraphFromMail')"
    >
      <div class="inpt-title">{{ "msGraphFromMail" | transloco }}</div>
      <input
        formControlName="msGraphFromMail"
        type="text"
        class="inpt"
        placeholder="{{ 'msGraphFromMail' | transloco }}"
        autocomplete="off"
      />
    </div>

    <div
      class="form-group form-floating mb-3"
      [appValidateState]="Form.get('msGraphTenantId')"
    >
      <div class="inpt-title">{{ "msGraphTenantId" | transloco }}</div>
      <input
        formControlName="msGraphTenantId"
        type="text"
        class="inpt"
        placeholder="{{ 'msGraphTenantId' | transloco }}"
        autocomplete="off"
      />
    </div>
    <div class="form-group form-floating mb-3 d-flex">
      <div class="col-6">
        <div class="inpt-title">{{ "useForSystemMails" | transloco }}</div>
        <input
          formControlName="useForSystemMails"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="col-6">
        <div class="inpt-title">{{ "customBusinessCard" | transloco }}</div>
        <input
          formControlName="customBusinessCard"
          class="form-check-input"
          type="checkbox"
        />
      </div>
    </div>
    <p-editor
      class="editor"
      [placeholder]="'customBusinessCardContent'"
      [style]="{ minHeight: '150px' }"
      formControlName="customBusinessCardContent"
      *ngIf="Form.get('customBusinessCard')?.value"
    >
      <ng-template pTemplate="header">
        <app-editor [allowImageInsert]="true"></app-editor
      ></ng-template>
    </p-editor>
  </div>
</form>

<div class="row mt-4">
  <div class="col-12 col-sm-6">
    <button
      [disabled]="Form!.pristine"
      (click)="formResult()"
      class="w-100 btn btn-orange"
    >
      {{ "save" | transloco }}
    </button>
  </div>
  <div class="col-12 col-sm-6">
    <button (click)="cancel()" class="w-100 btn btn-dark">
      {{ "Cancel" | transloco }}
    </button>
  </div>
</div>
